import { Layout, Divider, Flex, Typography } from "antd";
import styled from "styled-components";
import { ReactComponent as LasuLogo } from "../assets/icons/LasuLogo.svg";

const { Text } = Typography;

export const AppLayout = styled(Layout)`
  min-height: 100vh;
  height: 100vh;
  direction: rtl;
`;

export const ScreeenLayout = styled(Layout)`
  padding-top: 2.2rem;
  background: #ffffff;
  height: 100vh;
  max-height: 100vh;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #94a5f2;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const AppContent = styled(Layout.Content)`
  background: #ffffff;
`;

export const AppDivider = styled(Divider)`
  margin: 0;
`;

export const FullHeightSpin = styled(Flex).attrs({
  vertical: true,
  gap: 20,
})`
  justify-content: center;
  align-items: center;
  height: 80vh;
`;

export const StyledBigLasuLogo = styled(LasuLogo)`
  width: 33px;
  height: 34px;
  margin: 5px;
`;

export const StyledLogoText = styled(Text)`
  font-size: 30px;
  font-weight: 600;
  color: #313131;
  display: flex;
  align-items: center;
`;
